import { forwardRef } from 'react';
import { TextField } from '@mui/material';

const InputPhoneField = (props, ref) => {
  return (
    <TextField {...props} inputRef={ref} variant="outlined" margin="dense" fullWidth required />
  );
};
export default forwardRef(InputPhoneField);
